/*
  bb-plate.js — il blocco "personalizza il tuo pezzo" con l'anteprima della targhetta.

  IL PUNTO DELICATO: NON SI TOCCA L'APP
  I due campi (anno e modello dell'auto, messaggio da incidere) li mette l'app
  Tepo Product Options. Non li si sostituisce e non li si spegne: si nascondono e
  si RIEMPIONO da qui. Cosi' la validazione dell'app continua a funzionare, e in
  magazzino l'ordine arriva con le stesse proprieta' di sempre. Se un domani
  l'app viene disinstallata, questo blocco non compare e la scheda torna com'era.

  PERCHE' NON METTERE INPUT NOSTRI CON name="properties[...]"
  Perche' finirebbero nel form INSIEME a quelli dell'app, e Shopify tiene
  l'ultimo del POST: il messaggio del cliente sparirebbe senza errore a video.

  DOVE VA
  Subito prima del widget dell'app, che sta nella buy box fra prezzo e quantita'.
  Si aspetta che l'app abbia finito di disegnare (e' Vue, arriva dopo il DOM).

  SENZA L'APP (28 ott 2026)
  Chris non vedeva anno/modello e targhetta su 10 ordini del sito in un mese:
  alcuni prodotti (S63 Gen 2 "copy", C200 M274, Defender Octa...) non sono
  nel set di campi di Tepo, quindi il blocco non compariva e l'ordine partiva
  vuoto. Ora, se il prodotto e' un intake (data-need, deciso in theme.liquid) e
  l'app non disegna niente entro qualche secondo, il blocco si costruisce da
  solo e scrive nell'ordine le STESSE due proprieta' che scriveva l'app. Se
  l'app arriva tardi, il suo widget si nasconde e si riempie come sempre.
*/
(function () {
  'use strict';
  if (window.__bbPlate) return;
  window.__bbPlate = true;

  var PLATE = document.currentScript && document.currentScript.getAttribute('data-plate');
  var NEED = document.currentScript && document.currentScript.getAttribute('data-need') === '1';
  var DEFAULT_MSG = 'Handcrafted with Passion';
  // i nomi esatti che l'app scrive nell'ordine: Chris li legge da li'
  var PROPS = { auto: 'Enter the Year and Model of Vehicle', msg: 'Custom Message: Handcrafted for ______' };

  /* Il modulo vero del prodotto (quello a cui punta la quantita'), non il primo
     della pagina: il primo e' quello delle rate Shop Pay. */
  function formVero() {
    var q = document.querySelector('input[name="quantity"][form]');
    var f = q && document.getElementById(q.getAttribute('form'));
    return f ||
      document.querySelector('product-form form[action*="/cart/add"]') ||
      document.querySelector('form[action*="/cart/add"]:not(.installment)');
  }

  function testoDi(el) { return (el.textContent || '').replace(/\s+/g, ' ').trim(); }

  /* I campi dell'app, riconosciuti dall'etichetta e non dalla posizione:
     se domani l'ordine cambia nell'app, qui non si rompe niente. */
  function campiApp(widget) {
    var out = { auto: null, msg: null };
    var campi = widget.querySelectorAll('.tcustomizer-field');
    for (var i = 0; i < campi.length; i++) {
      var lab = campi[i].querySelector('.tcustomizer-field__heading');
      var testo = lab ? testoDi(lab).toLowerCase() : '';
      var input = campi[i].querySelector('input, textarea');
      if (!input) continue;
      if (/year|model|vehicle/.test(testo)) out.auto = input;
      else if (/message|handcrafted/.test(testo)) out.msg = input;
    }
    return out;
  }

  /* Scrivere in un campo di un'app fatta in Vue: assegnare .value non basta,
     il framework non se ne accorge. Serve il setter nativo piu' gli eventi. */
  function scrivi(input, valore) {
    if (!input) return;
    var proto = input instanceof HTMLTextAreaElement
      ? window.HTMLTextAreaElement.prototype : window.HTMLInputElement.prototype;
    var setter = Object.getOwnPropertyDescriptor(proto, 'value');
    if (setter && setter.set) setter.set.call(input, valore);
    else input.value = valore;
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function costruisci(widget, app) {
    // senza l'app "widget" e' solo il punto davanti a cui mettere il blocco
    var conApp = !!app;
    app = app || { auto: null, msg: null };
    var el = document.createElement('div');
    el.className = 'bb-plate';
    el.innerHTML =
      '<div class="bb-plate__head">' +
        '<span class="bb-plate__kick">Personalization</span>' +
        '<span class="bb-plate__note">Engraved before dispatch</span>' +
      '</div>' +

      '<div class="bb-plate__f" data-f>' +
        '<label class="bb-plate__lab" for="bbPlateVeh">' +
          '<span class="bb-plate__n">01</span>' +
          '<span class="bb-plate__t">Year and model of vehicle <span class="bb-plate__req">*</span></span>' +
        '</label>' +
        '<div class="bb-plate__wrap">' +
          '<input class="bb-plate__in" id="bbPlateVeh" type="text" maxlength="100" ' +
                 'placeholder="Example: 2016 GLE63S" autocomplete="off">' +
          '<span class="bb-plate__c" data-c="bbPlateVeh">0/100</span>' +
        '</div>' +
        '<p class="bb-plate__hint">We use it to double-check the fit before we ship.</p>' +
      '</div>' +

      '<div class="bb-plate__f" data-f>' +
        '<label class="bb-plate__lab" for="bbPlateName">' +
          '<span class="bb-plate__n">02</span>' +
          '<span class="bb-plate__t">Name on the plate <span class="bb-plate__req">*</span></span>' +
        '</label>' +
        '<div class="bb-plate__wrap">' +
          // 12 caratteri come su blackboost.com: e' la lunghezza che l'incisore
          // riesce a fare stare nella fascia libera senza rimpicciolire il testo.
          '<input class="bb-plate__in" id="bbPlateName" type="text" maxlength="12" ' +
                 'placeholder="Example: Samuel (12 characters max)" autocomplete="off" ' +
                 'autocapitalize="words" spellcheck="false">' +
          '<span class="bb-plate__c" data-c="bbPlateName">0/12</span>' +
        '</div>' +
        '<p class="bb-plate__hint">The plate always reads <b>Handcrafted for</b>. Just add the name, 12 characters max.</p>' +
        '<button type="button" class="bb-plate__chip" data-def aria-pressed="false">Use our default message</button>' +
      '</div>' +

      '<div class="bb-plate__pv">' +
        '<div class="bb-plate__pvh">' +
          '<span class="bb-plate__pvt">Engraving preview</span>' +
          '<span class="bb-plate__pvt">Updates as you type</span>' +
        '</div>' +
        '<div class="bb-plate__plate is-sample" data-plate>' +
          (PLATE ? '<img class="bb-plate__img" src="' + PLATE + '" width="400" height="124" decoding="async" ' +
                   'alt="Brushed metal blackboost plate, engraved with your name">' : '') +
          '<span class="bb-plate__eng"><span class="bb-plate__engt" data-eng></span></span>' +
        '</div>' +
        '<p class="bb-plate__cap">Hand engraved on the plate that ships with your part.</p>' +
        '<span class="bb-plate__sr" role="status" aria-live="polite" data-live></span>' +
      '</div>';

    widget.parentNode.insertBefore(el, widget);
    if (conApp) widget.classList.add('bb-plate-hidden');

    /*
      L'AGGIUNTA AL CARRELLO LA FA IL TEMA, NON L'APP.
      L'app aggiunge e poi manda alla pagina /cart. Sebastiano vuole il carrello
      a tendina e mai quella pagina, quindi si spegne il bottone dell'app e si
      riaccende quello del tema, che fa la chiamata a /cart/add.js e apre la
      tendina da solo.
      Perche' si puo' fare senza perdere niente: i campi dell'app non hanno un
      "name", quindi da soli non finirebbero nel modulo; ci pensano questi due
      campi nascosti, con gli stessi nomi esatti che l'app scrive nell'ordine
      (letti dal carrello vero: "Enter the Year and Model of Vehicle" e
      "Custom Message: Handcrafted for ______"). I due campi tecnici dell'app,
      _itemKey e _optionSetId, stanno gia' nel modulo e partono da soli.
    */
    var formProdotto = formVero();
    var nascosti = {};
    if (formProdotto) {
      var etichette = { auto: conApp ? null : PROPS.auto, msg: conApp ? null : PROPS.msg };
      var campi = widget.querySelectorAll('.tcustomizer-field');
      for (var k = 0; k < campi.length; k++) {
        var h = campi[k].querySelector('.tcustomizer-field__heading');
        var t = h ? testoDi(h).replace(/\s*\*\s*$/, '') : '';
        var inp = campi[k].querySelector('input, textarea');
        if (!inp) continue;
        if (inp === app.auto) etichette.auto = t;
        if (inp === app.msg) etichette.msg = t;
      }
      ['auto', 'msg'].forEach(function (chiave) {
        var nome = etichette[chiave];
        if (!nome) return;
        // se un giro precedente ne aveva gia' messo uno, si riusa: due campi con
        // lo stesso name manderebbero il valore due volte
        var i = formProdotto.querySelector('input[data-bb-prop="' + chiave + '"]');
        if (!i) {
          i = document.createElement('input');
          i.type = 'hidden';
          i.setAttribute('data-bb-prop', chiave);
          formProdotto.appendChild(i);
        }
        i.name = 'properties[' + nome + ']';
        nascosti[chiave] = i;
      });

      /*
        L'app ridisegna il suo bottone quando vuole (cambio variante, fine del
        suo caricamento), e ogni volta torna al suo posto. Non basta spegnerlo
        una volta: si tiene il punto per qualche secondo e a ogni modifica del
        modulo. Dopo 15 secondi si smette, che e' molto piu' del tempo che
        l'app ci mette a finire.
      */
      var tieniIlPunto = function () {
        var suo = document.querySelector('[name="tcustomizer-add"]');
        if (suo) suo.classList.add('bb-plate-hidden');
        // L'app spegne il bottone del tema con una SUA classe
        // (.tcustomizer-hide-button, display:none). Toglierla e' piu' pulito
        // che rincorrerla col CSS: il suo foglio si carica dopo il nostro,
        // quindi a parita' di !important vincerebbe lei.
        var nostri = document.querySelectorAll('button[name="add"], .product-form__submit');
        for (var z = 0; z < nostri.length; z++) {
          var n = nostri[z];
          n.classList.remove('tcustomizer-hide-button');
          n.classList.add('bb-plate-show');
          n.removeAttribute('disabled');
          n.style.removeProperty('display');
          n.style.removeProperty('visibility');
        }
      };
      tieniIlPunto();
      var moBtn = new MutationObserver(tieniIlPunto);
      moBtn.observe(formProdotto.parentNode || formProdotto, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'class', 'disabled'] });
      var battito = setInterval(tieniIlPunto, 400);
      setTimeout(function () { clearInterval(battito); moBtn.disconnect(); tieniIlPunto(); }, 15000);
    }

    var veh   = el.querySelector('#bbPlateVeh');
    var nome  = el.querySelector('#bbPlateName');
    var eng   = el.querySelector('[data-eng]');
    var plate = el.querySelector('[data-plate]');
    var chip  = el.querySelector('[data-def]');
    var live  = el.querySelector('[data-live]');
    var img   = el.querySelector('.bb-plate__img');
    var tLive;

    // se l'app aveva gia' dei valori (ritorno indietro del browser), si riprendono
    if (app.auto && app.auto.value) veh.value = app.auto.value;
    if (app.msg && app.msg.value) {
      var m = /^handcrafted for (.+)$/i.exec(app.msg.value.trim());
      nome.value = m ? m[1] : (/passion/i.test(app.msg.value) ? 'Default' : app.msg.value);
    }

    function conta(x) {
      var c = el.querySelector('[data-c="' + x.id + '"]');
      if (c) c.textContent = x.value.length + '/' + x.getAttribute('maxlength');
      x.closest('[data-f]').classList.toggle('is-done', !!x.value.trim());
    }

    /*
      La misura di partenza e' quella di blackboost.com: 3.6% della larghezza
      della targhetta. Se il nome e' lungo si scende, ma non sotto il 2.4%,
      perche' sotto non si legge piu' (ed e' il campo a doversi fermare).
    */
    function adatta() {
      var box = eng.parentNode;
      if (!plate.clientWidth) return;
      var s = 3.6, giri = 0;
      eng.style.fontSize = s + 'cqw';
      while (giri++ < 20 && s > 2.4 &&
             (eng.scrollWidth > box.clientWidth || eng.scrollHeight > box.clientHeight)) {
        s -= 0.1;
        eng.style.fontSize = s + 'cqw';
      }
    }

    function disegna(animare) {
      var v = (nome.value || '').replace(/\s+/g, ' ').trim();
      var esempio = !v;
      var inciso = esempio ? 'Handcrafted for Samuel'
                 : v.toLowerCase() === 'default' ? DEFAULT_MSG
                 : 'Handcrafted for ' + v;
      plate.classList.toggle('is-sample', esempio);
      if (eng.textContent !== inciso) {
        eng.textContent = inciso;
        if (animare) { eng.classList.remove('is-fresh'); void eng.offsetWidth; eng.classList.add('is-fresh'); }
      }
      adatta();
      chip.setAttribute('aria-pressed', String(v.toLowerCase() === 'default'));
      // quello che va in magazzino e' la frase esatta che verra' incisa
      scrivi(app.msg, esempio ? '' : inciso);
      if (nascosti.msg) nascosti.msg.value = esempio ? '' : inciso;
      clearTimeout(tLive);
      tLive = setTimeout(function () { live.textContent = 'The plate reads: ' + inciso; }, 700);
    }

    veh.addEventListener('input', function () {
      veh.classList.remove('is-bad'); conta(veh); scrivi(app.auto, veh.value);
      if (nascosti.auto) nascosti.auto.value = veh.value;
    });
    nome.addEventListener('input', function () {
      nome.classList.remove('is-bad'); conta(nome); disegna(true);
    });
    chip.addEventListener('click', function () {
      nome.value = nome.value.toLowerCase() === 'default' ? '' : 'Default';
      conta(nome); disegna(true); nome.focus();
    });

    if (img) {
      img.addEventListener('error', function () { plate.classList.add('is-off'); adatta(); });
      img.addEventListener('load', adatta);
    } else { plate.classList.add('is-off'); }
    window.addEventListener('resize', adatta);
    if (window.ResizeObserver) new ResizeObserver(adatta).observe(plate);

    /*
      DUE BOTTONI, NON UNO. L'app aggiunge il SUO bottone "Add to cart"
      (name="tcustomizer-add", type="button") accanto a quello del tema: il suo
      non fa partire il submit del form, chiama codice suo. Quindi il controllo
      va agganciato a tutti e due, se no cliccando il bottone dell'app con i
      campi vuoti non succede niente e non si capisce perche': il messaggio di
      errore dell'app sta dentro il widget, che qui e' nascosto.
    */
    function mancante() {
      var primo = null;
      [veh, nome].forEach(function (x) {
        var vuoto = !x.value.trim();
        x.classList.toggle('is-bad', vuoto);
        if (vuoto) primo = primo || x;
      });
      if (primo) {
        primo.focus({ preventScroll: true });
        primo.scrollIntoView({ block: 'center', behavior: 'smooth' });
      }
      return primo;
    }

    // il bottone della riga d'acquisto (bb-buyrow.js) chiede a noi se i campi
    // obbligatori sono pieni: la validazione sta in un posto solo
    window.__bbPlateValida = mancante;
    // per bb-consent.js: i bottoni di pagamento veloce restano spenti finche'
    // i due campi sono vuoti (Shop Pay "Buy now" saltava il controllo)
    window.__bbPlateVuoto = function () { return !veh.value.trim() || !nome.value.trim(); };
    function avvisa() { document.dispatchEvent(new CustomEvent('bb:plate')); }
    veh.addEventListener('input', avvisa);
    nome.addEventListener('input', avvisa);
    chip.addEventListener('click', avvisa);

    /*
      COPIA NEI DETTAGLI DELL'ORDINE (28 ott 2026)
      Sui bundle (Simple Bundles) la riga si spezza nei singoli pezzi e le
      proprieta' della riga si perdono: #3960, #3976, #4005 sono arrivati
      senza anno/modello ne' targhetta. Gli attributi del carrello invece
      arrivano sempre, e Chris li vede in "Additional details" dell'ordine.
      Una chiave per prodotto, cosi' due intake nello stesso carrello non si
      sovrascrivono.
    */
    document.addEventListener('bb:added-to-cart', function () {
      var v = veh.value.trim(), n = nome.value.replace(/\s+/g, ' ').trim();
      if (!v || !n) return;
      var titolo = (document.querySelector('.product__title h1') || document.querySelector('h1') || {}).textContent || document.title;
      titolo = titolo.replace(/\s+/g, ' ').trim().slice(0, 70);
      var plate = n.toLowerCase() === 'default' ? DEFAULT_MSG : 'Handcrafted for ' + n;
      var attr = {};
      attr['Vehicle & plate - ' + titolo] = v + ' | ' + plate;
      fetch((window.routes && window.routes.cart_update_url ? window.routes.cart_update_url : '/cart/update') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: attr })
      }).catch(function () {});
    });

    // l'app arriva dopo che il blocco e' gia' fatto: si nasconde e si riempie
    if (!conApp) {
      var moTardi = new MutationObserver(function () {
        var w = document.querySelector('.tcustomizer-product-form:not(.bb-plate-hidden)');
        if (!w) return;
        var a = campiApp(w);
        if (!a.auto || !a.msg) return;
        w.classList.add('bb-plate-hidden');
        app.auto = a.auto; app.msg = a.msg;
        scrivi(app.auto, veh.value);
        disegna(false);
      });
      moTardi.observe(document.body, { childList: true, subtree: true });
      setTimeout(function () { moTardi.disconnect(); }, 30000);
    }
    avvisa();

    var form = formVero();
    if (form) {
      form.addEventListener('submit', function (e) {
        if (mancante()) e.preventDefault();
      }, true);
    }

    document.addEventListener('click', function (e) {
      var b = e.target && e.target.closest
        ? e.target.closest('[name="tcustomizer-add"], button[name="add"], form[action*="/cart/add"] [type="submit"], .product-form__buttons .shopify-payment-button')
        : null;
      if (!b) return;
      if (mancante()) { e.preventDefault(); e.stopPropagation(); }
    }, true);

    conta(veh); conta(nome); disegna(false);
  }

  function prova() {
    var widget = document.querySelector('.tcustomizer-product-form:not(.bb-plate-hidden)');
    if (!widget || document.querySelector('.bb-plate')) return false;
    var app = campiApp(widget);
    if (!app.auto || !app.msg) return false;     // non e' il nostro set di campi
    costruisci(widget, app);
    return true;
  }

  /* Senza l'app: il blocco va davanti alla riga quantita' + bottone, dove
     l'app avrebbe messo il suo widget. */
  function provaDaSolo() {
    if (!NEED || document.querySelector('.bb-plate')) return;
    var punto = document.querySelector('.bb-buyrow-line') ||
      document.querySelector('.product-form__input--quantity') ||
      document.querySelector('.product-form__buttons');
    if (!punto || !formVero()) return;
    costruisci(punto, null);
  }

  // l'app disegna dopo, e ridisegna quando cambia variante: si resta in ascolto
  if (!prova()) {
    var mo = new MutationObserver(function () { if (prova()) mo.disconnect(); });
    mo.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { mo.disconnect(); }, 20000);
    // l'app di solito c'e' in 1-3 secondi; dopo 4 si fa da soli
    if (NEED) setTimeout(function () { mo.disconnect(); provaDaSolo(); }, 4000);
  }
})();
